import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare const kakao: any;

@Injectable({
  providedIn: 'root',
})
export class KakaoLoaderService {
  private loaded = false;
  private loadPromise: Promise<void> | null = null;

  /**
   * 카카오맵 SDK를 동적으로 로드합니다.
   * @returns Promise<void>
   */
  load(): Promise<void> {
    if (this.loaded) {
      return Promise.resolve();
    }

    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${environment.kakao.clientId}&libraries=services&autoload=false`;

      script.onload = () => {
        kakao.maps.load(() => {
          this.loaded = true;
          resolve();
        });
      };

      script.onerror = () => {
        reject(new Error('카카오맵 SDK 로드에 실패했습니다.'));
      };

      document.head.appendChild(script);
    });

    return this.loadPromise;
  }

  /**
   * 카카오맵 SDK가 로드되었는지 확인합니다.
   */
  isLoaded(): boolean {
    return this.loaded;
  }
}
